import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '../../material.module';
import { RoleService } from '../../services/role.service';
import { BreadcrumbsModule } from '../breadcrumbs/breadcrumbs.module';
import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutComponent } from './layout.component';

import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { NotificationComponent } from './components/notifications/notification/notification.component';
import { NotificationsComponent } from './components/notifications/notifications.component';

@NgModule({
	declarations: [
		LayoutComponent,
		ConfirmDialogComponent,
		NotificationsComponent,
		NotificationComponent,
		LoadingComponent
	],
	imports: [
		CommonModule,
		MaterialModule,
		LayoutRoutingModule,
		BreadcrumbsModule
	],
	exports: [
		LayoutComponent,
		ConfirmDialogComponent
	],
	providers: [
		RoleService
	]
})
export class LayoutModule { }
